export const DEFAULT_LAST_NAME = 'Last name';

export const showLoginPrompt = () => {
  // @ts-ignore
  google.accounts.id.prompt(notification => {
    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
      document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
      // @ts-ignore
      google.accounts.id.prompt();
    }
  });
};
